import React, { useState, useEffect } from "react";
import { Skeleton, Table } from "antd";

export default function TableWithSkeleton({
  columns,
  data,
  loading,
  length = 10,
  onChange,
  rowClassName,
  rowKey,
  showIndexColumn = false,
  page = 1,
  pageSize = 10,
  pagination = false,
  expandable = null,
  expandedRowRender = null,
  expandedRowColumns = null,
  expandRowByClick = false,
  defaultExpandAllRows = false,
  expandedRowKeys = null,
  onExpand = null,
  onExpandedRowsChange = null,
  rowExpandable = null,
  indentSize = 15,
  expandIcon = null,
  expandIconColumnIndex = 0,
}) {
  const [tableData, setTableData] = useState();
  const [rawData, setRawData] = useState(data);
  const [internalExpandedKeys, setInternalExpandedKeys] = useState([]);

  const numberColumn = {
    title: "No.",
    dataIndex: "no",
    render: (text, __, index) => {
      return loading ? (text) : (
        <span className="ps-2">{(page - 1) * pageSize + index + 1}</span>
      );
    },
    width: 50,
  };

  const finalColumns = !loading && showIndexColumn ? [numberColumn, ...columns] : columns;

  useEffect(() => {
    let skeletonObj = new Object();
    columns.map((item) => {
      skeletonObj[item?.dataIndex] = (
        <Skeleton.Input className="table-skeleton" active={true} />
      );
    });
    setTableData(Array.from({ length }, (v) => skeletonObj));
  }, [columns, length]);

  useEffect(() => {
    setRawData(data);
  }, [data]);

  const handleExpand = (expanded, record) => {
    const key = record.key || record.userId || record.id;
    if (expanded) {
      setInternalExpandedKeys(prev => [...prev, key]);
    } else {
      setInternalExpandedKeys(prev => prev.filter(k => k !== key));
    }
    if (onExpand) {
      onExpand(expanded, record);
    }
  };

  const handleExpandedRowsChange = (keys) => {
    setInternalExpandedKeys(keys);
    if (onExpandedRowsChange) {
      onExpandedRowsChange(keys);
    }
  };

  useEffect(() => {
    if (!loading && data?.length && expandedRowRender) {
      const allKeys = data.map(
        (row) => row.key || row.userId || row.id
      );
      setInternalExpandedKeys(allKeys);
    }
  }, [loading, data]);

  const expandableConfig = expandable || (expandedRowRender && {
    expandedRowRender: loading ? () => null : expandedRowRender,
    expandRowByClick,
    defaultExpandAllRows,
    expandedRowKeys: loading
      ? []
      : (expandedRowKeys !== null ? expandedRowKeys : internalExpandedKeys),
    onExpand: handleExpand,
    onExpandedRowsChange: handleExpandedRowsChange,
    rowExpandable: rowExpandable || (() => true),
    indentSize,
    expandIcon,
    expandIconColumnIndex,
  });

  return (
    <Table
      className="table-responsive"
      rowKey={(record) => (typeof rowKey === 'function' ? rowKey(record) : rowKey) || record?.id}
      rowClassName={(record, index) => {
        const baseClass = rowClassName ? rowClassName(record, index) : "";
        return `${baseClass} table-row-bg`.trim();
      }}
      sortDirections={false}
      columns={finalColumns}
      dataSource={loading ? tableData : rawData}
      pagination={pagination}
      onChange={onChange}
      expandable={expandableConfig}
    />
  );
}
